require.config({
  useMinified: true,
  baseUrl: getBaseUrl() + '/Scripts/',
  paths: {
    'whatinput': 'commun/dist/a11y/what-input',
    'whatinput-ie8-event': 'commun/dist/a11y/ie8/EventListener',
    'whatinput-ie8-indexOf': 'commun/dist/a11y/ie8/indexOf',
    'jquery': 'commun/dist/jquery.min',
    'jquery.language.detection': 'commun/dist/plugins/jquery.language.detection.min',
    'require': 'commun/dist/require',
    'async': 'commun/dist/require/async',
    'domReady': 'commun/dist/domReady',
    'matchHeight': 'commun/dist/plugins/jquery.matchHeight.min',
    'commun-carousel-v2': 'commun/dist/plugins/swiper.jquery.min',
    'swiper': 'commun/dist/plugins/swiper.jquery.min',
    'swiper-6.5.4': 'commun/dist/plugins/swiper-6.5.4.min',
    'commun-carousel': 'commun/dist/plugins/jquery.carousel',
    'cookies': 'commun/dist/plugins/cookies',
    'lib-video': 'commun/dist/video',
    'videojs': 'commun/dist/plugins/videojs-7.12.3.min',
    'videojs-playlist': 'commun/dist/plugins/videojs-playlist-4.3.1.min',
    'videojs-youtube': 'commun/dist/plugins/videojs-youtube-2.6.1.min',
    'autosize': 'commun/dist/plugins/jquery.autosize.min',
    'textareaCounter.plugin': 'commun/dist/plugins/jquery.textareaCounter.plugin',
    'jquery.validate': 'commun/dist/plugins/jquery.validate',
    'modal': 'commun/dist/plugins/BootStrap/modal',
    'commun-lightbox': 'commun/dist/plugins/featherlight.min',
    'tooltip': 'commun/dist/plugins/BootStrap/tooltip',
    'jquery.migrate': 'commun/dist/plugins/jquery-migrate.min',
    'jquery.ui': 'commun/dist/plugins/jquery-ui.min',
    'jquery-ui-easing': 'commun/dist/plugins/jquery-ui-easing',
    'jquery.prettyPhoto': 'commun/dist/plugins/jquery.prettyPhoto',
    'commun-gallerie-images-triable': 'commun/dist/plugin/isotope.pkgd',
    'easypiechart': 'commun/dist/plugins/jquery.easypiechart.min',
    'jquery.touchSwipe': 'commun/dist/plugins/galerie-portfolio/jquery.touchSwipe',
    'sz_portfolio_lightbox': 'commun/dist/plugins/galerie-portfolio/sz_portfolio_lightbox',
    'bootstrap': 'commun/dist/plugins/Bootstrap/bootstrap.min',
    'commun-posteCanada': 'commun/dist/plugins/posteCanada',
    'moment': 'commun/dist/plugins/moment.min',
    'moment-with-locales': 'commun/dist/plugins/moment-with-locales.min',
    'moment-timezone-data': 'commun/dist/plugins/moment-timezone-with-data.min',
    'jquery.ui.widget': 'commun/dist/plugins/jquery.ui.widget',
    'jquery.iframe-transport': 'commun/dist/plugins/jquery.iframe-transport',
    'ultimate-video': 'commun/dist/plugins/FWDUVPlayer',
    'jquery.dataTables': 'commun/dist/plugins/data-tables/jquery.dataTables',
    'jquery.dataTables.v1-10-19': 'commun/dist/plugins/data-tables/jquery.dataTablesv1-19',
    'jquery.dataTables.v1-10-19.bootstrap4': 'commun/dist/plugins/data-tables/dataTablesv1-19.bootstrap4',
    'jquery.dataTables.pluginButtons': 'commun/dist/plugins/data-tables/dataTables.buttons',
    'jquery.dataTables.pluginButtons.html5': 'commun/dist/plugins/data-tables/dataTables.buttons.html5',
    'jquery.dataTables.pluginButtons.flash': 'commun/dist/plugins/data-tables/dataTables.buttons.html5',
    'datatablesPlugin': 'commun/dist/plugins/plugin-DataTable',
    'datatables.bootstrap': 'commun/dist/plugins/data-tables/dataTables.bootstrap',
    'datatables.responsive': 'commun/dist/plugins/data-tables/dataTables.responsive',
    'datatables.bootstrap.responsive': 'commun/dist/plugins/data-tables/responsive.bootstrap',
    'datatablesFR': 'commun/dist/plugins/jquery.dataTables.French',
    'datatables.loadmore': 'commun/dist/plugins/dataTables.loadmore',
    'jquery.counterup': 'commun/dist/plugins/jquery.counterup',
    'chart': 'commun/dist/plugins/chart',
    'flatpickr': 'commun/dist/flatpickr',
    'noUiSlider': 'commun/dist/plugins/nouislider',
    'masonry': 'commun/dist/plugins/masonry.pkgd.min',
    'canvas': 'ia/dist/canvas',
    'bootstrap-advenced-btn': 'ia/dist/plugins/bootstrap-advanced-btn',
    'knockout': 'ia/dist/knockout',
    'base64': 'ia/dist/base64.min',
    'bootstrap-slider': 'ia/dist/plugins/bootstrap-slider1.0.1',
    'formulaire-recrutement': 'commun/app/carrieres/formulaire-recrutement',
    'analytics_ia': 'commun/lib/analytics_ia',
    'lottie-player': 'commun/dist/lottie-player.min',
    'commun-tuilerie': 'commun/lib/plugins/jquery.tuilerie',
    'statedetector': 'commun/lib/plugins/jquery.stateChangeManager',
    'jquery.validate.additionalMethods': 'commun/lib/plugins/jquery.validate.additionalMethods',
    'loadingGif': 'commun/lib/loadingGif',
    'popover': 'commun/lib/plugins/BootStrap/popover-ia',
    'is-mobile': 'commun/lib/plugins/isMobile',
    'tabbable': 'commun/lib/plugins/tabbable',
    'focusTrap': 'commun/lib/plugins/focus-trap',
    'particles': 'commun/lib/plugins/particles',
    'animation-scroll': 'commun/lib/plugins/aos.min',
    'rating-stars': 'commun/lib/plugins/jquery.rating-stars.min',
    'fotorama': 'commun/lib/plugins/fotorama',
    'isInViewport': 'commun/lib/plugins/isInViewport',
    'commun-bootstrap-datepicker': 'commun/lib/plugins/Bootstrap/bootstrap-datepicker.min',
    'timepicker': 'commun/lib/plugins/timepicker',
    'rellax': 'commun/lib/plugins/rellax',
    'jarallax': 'commun/lib/plugins/jarallax.min',
    'jarallax-video': 'commun/lib/plugins/jarallax-video.min',
    'jarallax-element': 'commun/lib/plugins/jarallax-element.min',
    'smoothscroll': 'commun/lib/plugins/smoothscroll',
    'gambit-smoothscroll': 'commun/lib/plugins/gambit-smoothscroll',
    'commun-formulaire-outils': 'commun/lib/plugins/commun-formulaire-outils',
    'number': 'commun/lib/plugins/jquery.number.min',
    'sammy': 'commun/lib/plugins/sammy',
    'commun-compteur-caracteres': 'commun/lib/plugins/compteur-caracteres',
    'table-dropdown-responsive': 'commun/lib/plugins/table-dropdown-responsive',
    'compteur-mots': 'commun/lib/plugins/compteur-mots',
    'fileupload': 'commun/lib/plugins/fileupload',
    'jquery.fileupload': 'commun/lib/plugins/jquery.fileupload',
    'jquery.dataTables.rowGroup': 'commun/lib/plugins/DataTables/rowGroupCustom',
    'selectric': 'commun/lib/plugins/selectric-accessible',
    'jquery.selectric': 'commun/lib/plugins/selectric-accessible',
    'selectric-accessibility': 'commun/lib/plugins/selectric-accessibility',
    'remodal': 'commun/lib/plugins/remodal',
    'jquery.animNumber': 'commun/lib/plugins/jquery.animNumber',
    'pageTransitions': 'commun/lib/plugins/jquery.page-transitions.min',
    'liens-sociaux': 'commun/lib/plugins/liens-sociaux',
    'jquery-validate-additionalMethods': 'commun/lib/plugins/jquery.validate.additionalMethods',
    'switch': 'commun/lib/plugins/switch',
    'download-polyfill': 'commun/lib/plugins/download-polyfill',
    'knockout-extenders': 'ia/lib/plugins/knockout.extenders',
    'commun': 'commun/app/commun',
    'commun-menu-principal': 'commun/app/commun-menu-principal',
    'commun-balisage-faq': 'commun/app/commun-balisage-faq',
    'commun-menu-gauche': 'commun/app/commun-menu-gauche',
    'commun-accordeon': 'commun/app/commun-accordeon',
    'commun-array-extensions': 'commun/app/extensions/commun-array-extensions',
    'commun-video': 'commun/app/commun-video',
    'commun-video-playlist': 'commun/app/commun-video-playlist',
    'commun-pagination': 'commun/app/commun-pagination',
    'commun-courriel': 'commun/app/commun-courriel',
    'commun-formulaire-nux': 'commun/app/commun-formulaire-nux',
    'commun-formulaire-lead': 'commun/app/commun-formulaire-lead',
    'commun-carousel-manager-v2': 'commun/app/commun-carousel-manager-v2',
    'commun-carrousel-manager-v3': 'commun/app/commun-carrousel-manager-v3',
    'commun-carousel-manager': 'commun/app/commun-carousel-manager',
    'commun-tuilerie-manager': 'commun/app/commun-tuiles',
    'commun-tableau-media': 'commun/app/commun-tableau-media',
    'commun-galerie-images': 'commun/app/commun-galerie-images',
    'commun-graphique-pourcentage': 'commun/app/commun-graphique-pourcentage',
    'commun-onglet': 'commun/app/commun-onglet',
    'scroll-linked-animations': 'commun/app/utilities/scroll-linked-animations',
    'setup-sticky': 'commun/app/utilities/setup-sticky',
    'try-me-pooh': 'commun/app/utilities/try-me-pooh',
    'captcha': 'commun/app/utilities/captcha.min',
    'videojs-translation-fr': 'commun/app/commun-video-translation-fr',
    'file-upload-helper': 'commun/app/commun-file-upload-helper',
    'commun-grille-swiper': 'commun/app/commun-grille-swiper',
    'banniere-alerte': 'commun/app/commun-bandeau-alerte',
    'banniere-cookies': 'commun/app/commun-bandeau-cookies',
    'commun-calculateurs': 'commun/app/commun-calculateur-money',
    'coveoJsSearch': 'Coveo/CoveoJsSearch.WithDependencies.min',
    'coveoD3': 'Coveo/d3',
    'pageEditorDeferRefresh': 'Coveo/PageEditorDeferRefresh',
    'coveoForSitecorePolyfills': 'Coveo/CoveoForSitecorePolyfills',
    'coveoForSitecore': 'Coveo/CoveoForSitecore',
    'questionnaire-capital-valeur': 'ia/app/Pages-promotionnelles/capital-valeur/capital-valeur',
    'indice-transition': 'ia/app/Pages-promotionnelles/indice-transition/indice-transition',
    'calculateurREER': 'ia/app/Calculateurs/calculateur-reer/calculateur-reer',
    'uuid': 'ia/app/commun/uuid',
    'calculateurREER-envoyer-resultats': 'ia/app/Calculateurs/calculateur-reer/envoyer-resultats',
    'calculateurREER-pdf': 'ia/app/Calculateurs/calculateur-reer/gestion-pdf.calculateur-reer',
    'utils': 'ia/app/commun/utils',
    'buydown': 'ia/app/Calculateurs/pret-hypo/buydown',
    'formulaire-entraide': 'ia/app/Pages-promotionnelles/entraide/formulaire-entraide',
    'formulaire-lp-assurance-vie': 'ia/app/Pages-promotionnelles/lp-assurance-vie/formulaire-lp-assurance-vie',
    'formulaire-abonnement-infolettre': 'ia/app/Pages-promotionnelles/abonnement-infolettre/formulaire-abonnement-infolettre',
    'formulaire-bourse-yc': 'ia/app/Pages-promotionnelles/bourse-yc/formulaire-bourse-yc',
    'formulaire-vote-bourse-yc': 'ia/app/Pages-promotionnelles/bourse-yc/formulaire-vote-bourse-yc',
    'bloc-abonnement-infolettre': 'ia/app/infolettre/bloc-abonnement-infolettre',
    'fiche-conseiller': 'ia/app/FicheConseiller/fiche-conseiller.min',
    'modification-fiche-conseiller': 'ia/app/FicheConseiller/modification-fiche-conseiller.min',
    'fileupload-conseiller': 'ia/app/FicheConseiller/fileupload-conseiller',
    'formulaire-celiapp': 'ia/app/Formulaires/Celiapp/formulaire-celiapp',
    'formulaire-inscription-assurance-vie-temporaire': 'ia/app/Formulaires/AssuranceVieTemporaire/InscriptionAssuranceVieTemporaire',
    'lazy-images': 'commun/lib/plugins/lazy-images',
    'custom-dropdown': 'commun/app/design-system/components/custom-dropdown',
    'ia-collapse': 'commun/app/design-system/components/collapse',
    'ia-tooltip': 'commun/app/design-system/components/tooltip',
    'router-component': 'commun/app/personalization-components/router-component'
  },
  shim: {
    'whatinput': ['whatinput-ie8-event', 'whatinput-ie8-indexOf'],
    'coveoForSitecore': {
      deps: ['coveoJsSearch', 'coveoForSitecorePolyfills', 'coveoD3']
    },
    'jarallax': ['jquery'],
    'tooltip': ['jquery'],
    'masonry': ['jquery'],
    'flatpickr': {
      deps: ['jquery']
    },
    'matchHeight': {
      deps: ['jquery'],
      exports: 'jQuery.fn.matchHeight'
    },
    'autosize': {
      deps: ['jquery'],
      exports: 'jQuery.fn.autosize'
    },
    'textareaCounter.plugin': {
      deps: ['jquery'],
      exports: 'jQuery.fn.textareaCount'
    },
    'jquery.validate': {
      deps: ['jquery'],
      exports: 'jQuery.fn.validate'
    },
    'loadingGif': {
      deps: ['jquery'],
      exports: 'jQuery.fn.startLoading'
    },
    'popover': {
      deps: ['jquery']
    },
    'statedetector': {
      'deps': ['jquery']
    },
    'commun-lightbox': {
      'deps': ['jquery']
    },
    'commun-galerie-images': ['jquery.prettyPhoto'],
    'commun-tuilerie-manager': {
      'deps': ['jquery']
    },
    'jquery.prettyPhoto': ['jquery', 'matchHeight'],
    'commun-graphique-pourcentage': ['jquery', 'easypiechart'],
    'commun-onglet': ['jquery'],
    'jquery.fileupload': {
      'deps': ['jquery']
    },
    'jquery.ui.widget': {
      'deps': ['jquery']
    },
    'jquery.iframe-transport': {
      'deps': ['jquery']
    },
    'jquery.numscroller': {
      'deps': ['jquery']
    },
    'pageTransitions': ['jquery'],
    'number': {
      'deps': ['jquery']
    },
    'commun-formulaire-lead': ['jquery', 'analytics_ia', 'textareaCounter.plugin', 'autosize'],
    'questionnaire-capital-valeur': ['jquery', 'matchHeight', 'analytics_ia', 'pageTransitions'],
    'jquery.touchSwipe': ['jquery'],
    'sz_portfolio_lightbox': ['jquery', 'jquery.touchSwipe', 'bootstrap'],
    'commun-carousel-v2': {
      'deps': ['jquery']
    },
    'swiper': {
      'deps': ['jquery']
    },
    'commun': {
      'deps': ['jquery', 'matchHeight', 'popover', 'jquery-ui-easing']
    },
    'bootstrap-slider': {
      'deps': ['jquery']
    },
    'knockout-extenders': {
      'deps': ['knockout', 'noUiSlider', 'jquery']
    },
    'table-dropdown-responsive': {
      'deps': ['jquery']
    },
    'datatablesPlugin': {
      'deps': ['jquery.dataTables.v1-10-19']
    },
    'jquery.dataTables.v1-10-19': {
      'deps': ['jquery']
    },
    'jquery.animNumber': {
      'deps': ['jquery']
    },
    'datatables.v1-10-19.bootstrap': {
      'deps': ['jquery.dataTables.v1-10-19']
    },
    'moment-timezone-data': {
      'deps': ['moment']
    },
    'fotorama': {
      'deps': ['jquery']
    }
  },
  waitSeconds: '99'
});
function getBaseUrl() {
  var currentUrl = getCurrentScriptUrl() || '';
  // eslint-disable-next-line no-useless-escape
  return currentUrl ? currentUrl.replace(/^(.*\/\/[^\/?#]*).*$/, '$1') : '';
}
function getCurrentScriptUrl() {
  var configScriptTag = document.getElementById('main-require-config-script');
  if (configScriptTag) return configScriptTag.src;
}
require(['jquery', 'analytics_ia', 'jquery.language.detection', 'matchHeight', 'commun', 'statedetector', 'whatinput'], function ($, analytics_ia) {
  $(function () {
    // eslint-disable-next-line no-undef
    StateDetector.init();
  });
});

// regle le probleme de utag qui utilise trim() qui ne fonctionne pas dans ie8
if (typeof String.prototype.trim !== 'function') {
  String.prototype.trim = function () {
    return this.replace(/^\s+|\s+$/g, '');
  };
}

// Console-polyfill. MIT license.
// https://github.com/paulmillr/console-polyfill
// Make it safe to do console.log() always.
(function (global) {
  'use strict';

  global.console = global.console || {};
  var con = global.console;
  var prop;
  var method;
  var empty = {};
  var dummy = function dummy() {};
  var properties = 'memory'.split(',');
  var methods = ('assert,clear,count,debug,dir,dirxml,error,exception,group,' + 'groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,' + 'show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn').split(',');
  while (prop = properties.pop()) if (!con[prop]) con[prop] = empty;
  while (method = methods.pop()) if (!con[method]) con[method] = dummy;
})(typeof window === 'undefined' ? this : window);
// Using `this` for web workers while maintaining compatibility with browser
// targeted script loaders such as Browserify or Webpack where the only way to
// get to the global object is via `window`.

if (!String.prototype.splice) {
  String.prototype.splice = function (start, delCount, newSubStr) {
    return this.slice(0, start) + newSubStr + this.slice(start + Math.abs(delCount));
  };
}